import { ComponentStyleConfig } from '@chakra-ui/react'

export const Text: ComponentStyleConfig = {
    baseStyle: {
        color: 'green.default',
    },
    variants: {
        'paragraph-m': {
            fontWeight: 400,
            fontSize: '0.875rem',
            lineHeight: '1.3125rem',
        },
        'paragraph-m-bold': {
            fontWeight: 500,
            fontSize: '0.875rem',
            lineHeight: '1.3125rem',
        },
        'paragraph-s': {
            fontWeight: 400,
            fontSize: '0.75rem',
            lineHeight: '1.25rem',
        },
        'paragraph-xs': {
            fontWeight: 400,
            fontSize: '0.6875rem',
            lineHeight: '1.0625rem',
        },
        'paragraph-xxs': {
            fontWeight: 400,
            fontSize: '0.5625rem',
            lineHeight: '0.9375rem',
        },
        'caption-m': {
            fontWeight: 500,
            fontSize: '0.75rem',
            lineHeight: '0.9375rem',
        },
        'caption-s': {
            fontWeight: 500,
            fontSize: '0.625rem',
            lineHeight: '0.9375rem',
        },
        'caption-xs': {
            fontWeight: 500,
            fontSize: '0.5625rem',
            lineHeight: '0.875rem',
        },
        'caption-xxs': {
            fontWeight: 500,
            fontSize: '0.5rem',
            lineHeight: '0.75rem',
        },
    },
    defaultProps: {
        variant: 'paragraph-s',
    },
}
